




















































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { CustomerBillingModel } from '@/app/shared/models';
import { env } from '@/environments';
import Axios from 'axios';
@Component
export default class FormCustomerBillingComponent extends Vue {
  @Prop(Object) readonly customer!: CustomerBillingModel;

  private stateData: object[] = [];
  private menu = false;

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private get stateList() {
    return this.refs._.orderBy(this.stateData, 'sigla');
  }
  private get address() {
    return this.refs.modules.contract.address;
  }
  private get email() {
    return this.refs.modules.contract.email;
  }
  private get cellPhone() {
    return this.refs.modules.contract.cellPhone;
  }
  private get phone() {
    return this.refs.modules.contract.phone;
  }

  private async mounted() {
    this.address.CountryCode = 'BR';
    this.stateData = await Axios.get<object[]>(
      `${env.statesUri}/localidades/estados`
    ).then(({ data }) => data);
  }
  private onChangeCep() {
    if (this.address.PostalCode)
      Axios.get(`${env.postalCodeUri}/${this.address.PostalCode}/json/`)
        .then(({ data }) => {
          if (!data.erro) {
            this.$set(this.address, 'Street', data.logradouro);
            this.$set(this.address, 'Neighborhood', data.bairro);
            this.$set(this.address, 'City', data.localidade);
            this.$set(this.address, 'SubdivisionCode', data.uf);
          }
        })
        .catch(() => {
          //
        });
  }
}
